.toolbox {
  width: 100%;
  flex: 1;
  min-width: 0;
  height: 100%;
  box-sizing: border-box;
  background-color: var(--color-bg-panel);
  border-right: 1px solid var(--color-border);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.title {
  padding: 12px;
  font-size: 14px;
  font-weight: 600;
  color: var(--color-text);
  border-bottom: 1px solid var(--color-border);
  margin: 0;
}

.list {
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  background-color: var(--color-bg-base);
  border: 1px solid var(--color-border);
  border-radius: 4px;
  cursor: grab;
  user-select: none;
  transition: background-color 0.2s, border-color 0.2s;
}

.item:hover {
  background-color: var(--color-bg-hover);
  border-color: var(--color-primary);
}

.item:active {
  cursor: grabbing;
}

.icon {
  font-family: monospace;
  font-size: 16px;
  color: var(--color-text);
  margin-bottom: 4px;
  white-space: pre;
}

.label {
  font-size: 12px;
  color: var(--color-text-muted);
}

.itemActive {
  background-color: var(--color-primary-alpha-20, rgba(0, 120, 215, 0.25));
  border-color: var(--color-primary, #0078d7);
  box-shadow: 0 0 10px rgba(0, 120, 215, 0.35);
}

.activeBadge {
  margin-top: 4px;
  font-size: 10px;
  font-weight: bold;
  color: #38bdf8;
  background: rgba(56, 189, 248, 0.15);
  padding: 2px 8px;
  border-radius: 10px;
  border: 1px solid rgba(56, 189, 248, 0.4);
}
